import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function CanadaPage() {
  return <CountryPageTemplate country={countryPages.canada} />;
}

export default CanadaPage;

